import Table, { TableRow, TableCell } from "@amzn/meridian/esm/components/table";
import OutlineCard from "../../OutlineCard";

const StatusTable = ({ title, headers, rows, highlightRows }) => {
  const highlightSet = new Set(highlightRows || []);
  const hasHeaders = Array.isArray(headers) && headers.length > 0;

  return (
    <OutlineCard title={title}>
      <Table headerRows={hasHeaders ? 1 : 0} spacing="small" showStripes showDividers>
        {hasHeaders && (
          <TableRow highlightOnHover>
            {headers.map((header, i) => (
              <TableCell key={i}>{header}</TableCell>
            ))}
          </TableRow>
        )}
        {Array.isArray(rows) && rows.map((row, rowIdx) => (
          <TableRow key={rowIdx} highlightOnHover backgroundColor={highlightSet.has(rowIdx) ? "subdued" : undefined}>
            {Array.isArray(row) && row.map((cell, cellIdx) => (
              <TableCell key={cellIdx}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </Table>
    </OutlineCard>
  );
};

export default StatusTable;
